module.exports = __webpack_public_path__ + "media/buy-now/bag9-92405729.png";